export default "__VITE_ASSET__kuEAC9aK__"